import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { firstValueFrom } from 'rxjs';

import { DetailedEventViewModel } from '../event-details-common/event-details-common.models';
import { EventDetailsService } from '../event-details-common/event-details.service';
import { MarqueeTileService } from '../highlights-marquee/marquee-tile.service';

@Injectable({ providedIn: 'root' })
export class EventDetailsViewModelFetcher {
    constructor(
        protected eventDetailsService: EventDetailsService,
        protected marqueeTileService: MarqueeTileService,
    ) {}

    async get(eventId: string, promotedTemplates: number[]): Promise<DetailedEventViewModel> {
        const marqueeAvailable = await firstValueFrom(this.marqueeTileService.hasForFixture(eventId));

        const result: DetailedEventViewModel = {
            hasMarqueeAvailable: marqueeAvailable,
            promotedTemplate: promotedTemplates,
            tiles: [],
        };

        const response = await this.eventDetailsService.getModel(eventId);
        if (response?.model) {
            result.model = response.model;
            result.preCreated = response.preCreated;
            result.virtualCompetitionDetails = response.virtualCompetitionDetails;
            result.fixture = response.fixture;
            result.betBuilderFixture = response.betBuilderFixture;
            result.hasMarqueeAvailable = !response.model.live && marqueeAvailable;
        }

        return result;
    }

    resolve(route: ActivatedRouteSnapshot): Promise<DetailedEventViewModel> {
        const parseParams = (name: string) => route?.queryParamMap?.get(name) || '';

        const eventId = route.params.event as string;
        const promotedTemplate = parseParams('promotedTemplate')
            .split(',')
            .filter((template) => !!template)
            .map((template) => parseInt(template));

        return this.get(eventId, promotedTemplate);
    }
}
